export default __webpack_public_path__ + "static/media/profile-fs8.4461cbfc.jpg";